import { render } from "./custom-select.vue?vue&type=template&id=84927a90&scoped=true&ts=true"
import script from "./custom-select.vue?vue&type=script&lang=ts"
export * from "./custom-select.vue?vue&type=script&lang=ts"

import "./custom-select.vue?vue&type=style&index=0&id=84927a90&lang=less&scoped=true"

import exportComponent from "/opt/jenkins/workspace/WF-cloud-admin-beta/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84927a90"]])

export default __exports__